import { api } from '../api.js';
import { escapeHtml } from '../../../../src/shared/escape-html.js';

function formatDuration(totalSeconds) {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m`;
  return '<1m';
}

const SYSTEM_LABELS = {
  nes: 'NES', snes: 'SNES', gba: 'GBA', gb: 'GB', gbc: 'GBC',
  genesis: 'Genesis', atari2600: 'Atari', c64: 'C64',
};

export async function render() {
  const body = document.getElementById('admin-games-body');
  const status = document.getElementById('admin-games-status');
  if (!body) return;

  body.innerHTML = '<tr><td colspan="5" class="admin-loading">Loading top games…</td></tr>';

  try {
    const games = await api.get('/api/admin/top-games');

    if (!games.length) {
      body.innerHTML = '<tr><td colspan="5" class="admin-loading">No play sessions in the past 7 days.</td></tr>';
      return;
    }

    body.innerHTML = '';
    for (const g of games) {
      const row = document.createElement('tr');

      const coverSrc = g.game_id
        ? `/api/library/artwork/cover/${g.game_id}`
        : '';
      const coverHtml = coverSrc
        ? `<img class="admin-games-cover" src="${coverSrc}" alt="" loading="lazy">`
        : '<div class="admin-games-cover admin-games-cover-empty"></div>';

      const sysLabel = SYSTEM_LABELS[g.system_id] || g.system_id;

      const playersHtml = g.players.map(p => {
        const name = escapeHtml(p.display_username || p.username);
        const href = `/u/${encodeURIComponent(p.username)}`;
        return `<a href="${href}" class="admin-games-player" target="_blank">${name}</a> <span class="admin-games-player-time">${formatDuration(p.seconds)}</span>`;
      }).join('<br>');

      row.innerHTML =
        `<td class="admin-games-cover-cell">${coverHtml}</td>` +
        `<td><span class="admin-games-title">${escapeHtml(g.title)}</span><br><span class="admin-games-system">${escapeHtml(sysLabel)}</span></td>` +
        `<td class="admin-games-num">${formatDuration(g.total_seconds)}</td>` +
        `<td class="admin-games-num">${g.session_count.toLocaleString()}</td>` +
        `<td class="admin-games-players-cell">${playersHtml}</td>`;

      body.appendChild(row);
    }
  } catch (err) {
    body.innerHTML = `<tr><td colspan="5" class="admin-loading">Error: ${escapeHtml(err.message)}</td></tr>`;
    if (status) { status.textContent = err.message; status.className = 'admin-status error'; }
    console.error('[admin] top-games error:', err);
  }
}
